module.exports = __webpack_public_path__ + "img/News_item_13.6b821573.jpg";